import { createBrowserRouter, Navigate, Outlet } from 'react-router-dom';
import RootLayout from './__root';
import ErrorPage from './error';
import IndexRedirect from './index';
import HomePage from './home';
import EnglishPage from './english';
import OfflinePage from './offline';
import InventoryListPage from './inventory-list';
import PolitiqueConfidentialitePage from './politique-de-confidentialite';
import PrivacyPolicyPage from './privacy-policy.tsx';
import MentionsLegalesPage from './mentions-legales';
import PaymentLayout from './payment/__root';
import PaymentSuccessPage from './payment/success';
import PaymentCancelPage from './payment/cancel';
import AuthLandingPage from './auth/__root';
import AuthLoginPage from './auth/login';
import ForgotPasswordPage from './auth/forgot-password';
import ResetPasswordPage from './auth/reset-password';
import VerifyEmailPage from './auth/verify-email';
import SignupSuccessPage from './signup/success';
import AdminLayout from './admin/__root';
import SuperAdminLayout from './superadmin/__root';
import SuperAdminMenusPage from './superadmin/menus';
import SuperAdminFeaturesPage from './superadmin/features';
import SuperAdminAiUsagePage from './superadmin/ai-usage';
import SuperAdminAnnouncementsPage from './superadmin/announcements';
import SuperAdminDesignSystemPage from './superadmin/design-system';
import SuperAdminMobileReleasesPage from './superadmin/mobile-releases';
import SuperAdminMetricsPage from './superadmin/metrics';
import MaintenancePage from './maintenance';
import SuperAdminClientDetailPage from './superadmin/clients/$id';
import DashboardPage from './admin/dashboard';

import AccountPage from './admin/account';
import SubscriptionPage from './admin/subscription';
import FichesInterventionsPage from './admin/fiches-interventions';
import ContactsPage from './admin/contacts';
import PlantationsPage from './admin/plantations';
import SettingsPage from './admin/settings';
import SubscriptionSettingsPage from './superadmin/subscription-settings';
import PrintTemplatesPage from './admin/print-templates';
import PromoCodesPage from './superadmin/promo-codes';
import AiSettingsPage from './superadmin/ai/settings';
import AiAssistantPage from './admin/ai/assistant';
import SmartMapPage from './admin/smart-map';
import GeoLayersAdminPage from './admin/geo-layers';
import AuditLogsPage from './superadmin/audit-logs';
import SuperAdminUsersStatsPage from './superadmin/users/stats';
import PaymentLifecycleDebugPage from './superadmin/debug/payment-lifecycle';
import PaymentStatsDebugPage from './superadmin/debug/payment-stats';
import SendTestSmsDebugRoute from './superadmin/debug/send-test-sms';
import SubscriptionHelperDebugPage from './superadmin/debug/subscription-helper';
import ChampignonsPage from './admin/config-inventaire/champignons';
import EssencesPage from './admin/config-inventaire/essences';
import NuisiblesPage from './admin/config-inventaire/nuisibles';
import BibliothequeChampignonsPage from './admin/bibliotheque/champignons';
import BibliothequeEssencesPage from './admin/bibliotheque/essences';
import UtilisateurPage from './admin/droits/utilisateur/index';
import UtilisateurCreatePage from './admin/droits/utilisateur/create';
import UtilisateurDetailPage from './admin/droits/utilisateur/$id/index';
import UtilisateurEditPage from './admin/droits/utilisateur/$id/edit';
import ProfilPage from './admin/droits/profil';
import GroupePage from './admin/droits/groupe';
import GroupeCreatePage from './admin/droits/groupe/create';
import CreationRapidePage from './admin/droits/creation-rapide';
import GroupeDetailPage from './admin/droits/groupe/$id/index';
import GroupeEditPage from './admin/droits/groupe/$id/edit';
import InventairesPage from './admin/inventaires';
import TravauxPage from './admin/inventaires/travaux';
import NotValidatedPage from './admin/inventaires/not-validated';
import InventaireMapPage from './admin/inventaires/map';
import InventaireNewPage from './admin/inventaires/new';
import InventaireCreatePage from './admin/inventaires/create';
import AlertsPage from './admin/inventaires/alerts';
import MultiPrintArbrePage from './admin/inventaires/multi-print/arbre';
import MultiPrintEpaysagePage from './admin/inventaires/multi-print/epaysage';
import InventaireDetailLayout from './admin/inventaires/$id';
import InventaireDetailPage from './admin/inventaires/$id/index';
import ArbreDetailsPage from './admin/inventaires/$id/arbre/details';
import ArbreEditPage from './admin/inventaires/$id/arbre/edit';
import ArbreInterventionPage from './admin/inventaires/$id/arbre/intervention';
import ArbrePrintPage from './admin/inventaires/$id/arbre/print';
import EpaysageDetailsPage from './admin/inventaires/$id/epaysages/details';
import EpaysageEditPage from './admin/inventaires/$id/epaysages/edit';
import EpaysageInterventionPage from './admin/inventaires/$id/epaysages/intervention';

import EpaysagePrintAltStandalonePage from '@routes/inventaires/$id/epaysage/print-alt';
import VisitesPage from './admin/inventaires/visites';

const router: any = createBrowserRouter([
  {
    path: '/payment',
    element: <PaymentLayout />,
    errorElement: <ErrorPage />,
    children: [
      { path: 'success', element: <PaymentSuccessPage /> },
      { path: 'cancel', element: <PaymentCancelPage /> },
    ],
  },
  {
    path: '/',
    element: <RootLayout />,
    errorElement: <ErrorPage />,
    children: [
      { index: true, element: <IndexRedirect /> },
      { path: 'home', element: <HomePage /> },
      { path: 'english', element: <EnglishPage /> },
      { path: 'offline', element: <OfflinePage /> },
      { path: 'maintenance', element: <MaintenancePage /> },
      { path: 'inventory-list', element: <InventoryListPage /> },
      { path: 'politique-de-confidentialite', element: <PolitiqueConfidentialitePage /> },
      { path: 'privacy-policy', element: <PrivacyPolicyPage /> },
      { path: 'mentions-legales', element: <MentionsLegalesPage /> },
      {
        path: 'admin/inventaires/:id/epaysage/print',
        element: <EpaysagePrintAltStandalonePage />,
      },

      { path: 'admin/inventaires/:id/arbre/print', element: <ArbrePrintPage /> },
      { path: 'admin/inventaires/multi-print/arbre', element: <MultiPrintArbrePage /> },
      { path: 'admin/inventaires/multi-print/epaysage', element: <MultiPrintEpaysagePage /> },
      { path: 'admin/inventaires/:id/arbre/intervention', element: <ArbreInterventionPage /> },
      { path: 'admin/inventaires/:id/epaysage/intervention', element: <EpaysageInterventionPage /> },
      {
        path: 'auth',
        element: <Outlet />,
        errorElement: <ErrorPage />,
        children: [
          { index: true, element: <AuthLandingPage /> },
          { path: 'login', element: <AuthLoginPage /> },
          { path: 'forgot-password', element: <ForgotPasswordPage /> },
          { path: 'reset-password', element: <ResetPasswordPage /> },
          { path: 'verify-email', element: <VerifyEmailPage /> },
        ],
      },
      {
        path: 'signup',
        element: <Outlet />,
        errorElement: <ErrorPage />,
        children: [
          { path: 'success', element: <SignupSuccessPage /> },
        ],
      },
      {
        path: 'superadmin',
        element: <SuperAdminLayout />,
        errorElement: <ErrorPage />,
        children: [
          { index: true, element: <Navigate to="/superadmin/clients" replace /> },
          { path: 'metrics', element: <SuperAdminMetricsPage /> },
          { path: 'clients', element: <SuperAdminUsersStatsPage /> },
          { path: 'clients/:id', element: <SuperAdminClientDetailPage /> },
          { path: 'menus', element: <SuperAdminMenusPage /> },
          { path: 'features', element: <SuperAdminFeaturesPage /> },
          { path: 'ai-usage', element: <SuperAdminAiUsagePage /> },
          { path: 'announcements', element: <SuperAdminAnnouncementsPage /> },
          { path: 'design-system', element: <SuperAdminDesignSystemPage /> },
          { path: 'mobile-releases', element: <SuperAdminMobileReleasesPage /> },
          { path: 'subscription-settings', element: <SubscriptionSettingsPage /> },
          { path: 'promo-codes', element: <PromoCodesPage /> },
          { path: 'ai/settings', element: <AiSettingsPage /> },
          { path: 'audit-logs', element: <AuditLogsPage /> },
          { path: 'users/stats', element: <Navigate to="/superadmin/clients" replace /> },
          { path: 'debug/payment-lifecycle', element: <PaymentLifecycleDebugPage /> },
          { path: 'debug/payment-stats', element: <PaymentStatsDebugPage /> },
          { path: 'debug/send-test-sms', element: <SendTestSmsDebugRoute /> },
          { path: 'debug/subscription-helper', element: <SubscriptionHelperDebugPage /> },
        ],
      },
      {
        path: 'admin',
        element: <AdminLayout />,
        errorElement: <ErrorPage />,
        children: [
          { path: 'dashboard', element: <DashboardPage /> },

          { path: 'account', element: <AccountPage /> },
          { path: 'subscription', element: <SubscriptionPage /> },
          { path: 'fiches-interventions', element: <FichesInterventionsPage /> },
          { path: 'contacts', element: <ContactsPage /> },
          { path: 'plantations', element: <PlantationsPage /> },
          { path: 'settings', element: <SettingsPage /> },
          // Réglages plateforme déplacés dans /superadmin : les anciennes adresses y redirigent.
          { path: 'subscription-settings', element: <Navigate to="/superadmin/subscription-settings" replace /> },
          { path: 'promo-codes', element: <Navigate to="/superadmin/promo-codes" replace /> },
          { path: 'print-templates', element: <PrintTemplatesPage /> },
          { path: 'ai/settings', element: <Navigate to="/superadmin/ai/settings" replace /> },
          { path: 'ai/assistant', element: <AiAssistantPage /> },
          { path: 'smart-map', element: <SmartMapPage /> },
          { path: 'geo-layers', element: <GeoLayersAdminPage /> },
          { path: 'audit-logs', element: <Navigate to="/superadmin/audit-logs" replace /> },
          { path: 'users/stats', element: <Navigate to="/superadmin/clients" replace /> },
          { path: 'debug/payment-lifecycle', element: <Navigate to="/superadmin/debug/payment-lifecycle" replace /> },
          { path: 'debug/payment-stats', element: <Navigate to="/superadmin/debug/payment-stats" replace /> },
          { path: 'debug/send-test-sms', element: <Navigate to="/superadmin/debug/send-test-sms" replace /> },
          { path: 'debug/subscription-helper', element: <Navigate to="/superadmin/debug/subscription-helper" replace /> },
          {
            path: 'bibliotheque',
            element: <Outlet />,
            errorElement: <ErrorPage />,
            children: [
              { path: 'essences', element: <BibliothequeEssencesPage /> },
              { path: 'champignons', element: <BibliothequeChampignonsPage /> },
            ],
          },
          {
            path: 'config-inventaire',
            element: <Outlet />,
            errorElement: <ErrorPage />,
            children: [
              { path: 'champignons', element: <ChampignonsPage /> },
              { path: 'essences', element: <EssencesPage /> },
              { path: 'nuisibles', element: <NuisiblesPage /> },
            ],
          },
          {
            path: 'droits',
            element: <Outlet />,
            errorElement: <ErrorPage />,
            children: [
              { path: 'profil', element: <ProfilPage /> },
              { path: 'creation-rapide', element: <CreationRapidePage /> },
              {
                path: 'utilisateur',
                element: <Outlet />,
                errorElement: <ErrorPage />,
                children: [
                  { index: true, element: <UtilisateurPage /> },
                  { path: 'create', element: <UtilisateurCreatePage /> },
                  {
                    path: ':id',
                    element: <Outlet />,
                    children: [
                      { index: true, element: <UtilisateurDetailPage /> },
                      { path: 'edit', element: <UtilisateurEditPage /> },
                    ],
                  },
                ],
              },
              {
                path: 'groupe',
                element: <Outlet />,
                errorElement: <ErrorPage />,
                children: [
                  { index: true, element: <GroupePage /> },
                  { path: 'create', element: <GroupeCreatePage /> },
                  {
                    path: ':id',
                    element: <Outlet />,
                    children: [
                      { index: true, element: <GroupeDetailPage /> },
                      { path: 'edit', element: <GroupeEditPage /> },
                    ],
                  },
                ],
              },
            ],
          },
          {
            path: 'inventaires',
            element: <Outlet />,
            errorElement: <ErrorPage />,
            children: [
              { index: true, element: <InventairesPage /> },
              { path: 'visites', element: <VisitesPage /> },
              { path: 'alerts', element: <AlertsPage /> },
              { path: 'travaux', element: <TravauxPage /> },
              { path: 'not-validated', element: <NotValidatedPage /> },
              { path: 'map', element: <InventaireMapPage /> },
              { path: 'new', element: <InventaireNewPage /> },
              { path: 'create', element: <InventaireCreatePage /> },
              {
                path: ':id',
                element: <InventaireDetailLayout />,
                errorElement: <ErrorPage />,
                children: [
                  { index: true, element: <InventaireDetailPage /> },
                  {
                    path: 'arbre',
                    element: <Outlet />,
                    errorElement: <ErrorPage />,
                    children: [
                      { path: 'details', element: <ArbreDetailsPage /> },
                      { path: 'edit', element: <ArbreEditPage /> },


                    ],
                  },
                  {
                    path: 'epaysage',
                    element: <Outlet />,
                    errorElement: <ErrorPage />,
                    children: [
                      { path: 'details', element: <EpaysageDetailsPage /> },
                      { path: 'edit', element: <EpaysageEditPage /> },
                      { path: 'intervention', element: <EpaysageInterventionPage /> },

                    ],
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
  },
]);

export default router;

